import {
    CovariateRecords,
    Covid19Records,
    CroRecords,
    PopulationRecords,
    RiskExposureRecords,
    SdohRecords,
    SequelaOutcome,
} from './data-type';

export const TYPE_DATA_TABLE_CHART = 'table';
export const TYPE_LINE_CHART = 'line';
export const TYPE_MAP_CHART = 'map';
export const TYPE_BAR_CHART = 'bar';
export const TYPE_TREEMAP_CHART = 'treemap';
export const TYPE_SCATTER_MAP_CHART = 'scatter_map';
export const TYPE_ARROW_CHART = 'arrow';

export const CHARTS_NON_SUPPORTED_DATA_TYPES = {
    [TYPE_TREEMAP_CHART]: [
        CovariateRecords,
        SdohRecords,
        Covid19Records,
        PopulationRecords,
        RiskExposureRecords,
        SequelaOutcome,
        CroRecords,
    ],
};
